import * as Sentry from '@sentry/react';
import appEnv from 'app/config/appEnv';

Sentry.init({
  dsn: 'https://3bd68dc29d0002dfea359314158ca7d9@o4510125815103488.ingest.de.sentry.io/4510142721491024', // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: appEnv.VITE_ENV,
  // Local dev servers point VITE_ENV at a real environment (e.g. local-sit) so Cognito/API calls
  // resolve correctly — that would otherwise report every localhost error as if it came from that
  // real environment. Gate on the actual host instead of VITE_ENV.
  enabled: window.location.hostname !== 'localhost',
});

export default Sentry;
